export default __webpack_public_path__ + "static/media/Q4_2_resized.0348e4d0.jpg";